import { MButton, MInput } from '@Components/Base';
import { Checkbox, Flex, Typography } from 'antd';
import { ReactComponent as PlusAddIcon } from '@Icons/additional/plus-gradient.svg';
import { ReactComponent as SearchIcon } from '@Icons/additional/search-gradient.svg';
// import { ReactComponent as UploadIcon } from '@Icons/additional/upload.svg';
import { ReactComponent as CloseIcon } from '@Icons/additional/close-cross.svg';
import { ReactComponent as DeleteIcon } from '@Icons/additional/trash-gradient.svg';

import styles from './material-actions.module.css';

interface MaterialActionsProps {
  label: string;
  isSelected: boolean;
  isSearch: boolean;
  addedItemsCounter: number;
  handleAddMaterial: () => void;
  handleSelectAllItems: () => void;
  handleUnselectAllItems: () => void;
  handleDeleteAllSelectedItems: () => void;
  handleShowSearch: () => void;
  handleCloseSearch: () => void;
  handleSearchItems: (value: string) => void;
}

const MaterialActions: React.FC<MaterialActionsProps> = ({
  handleAddMaterial,
  handleSelectAllItems,
  handleUnselectAllItems,
  handleDeleteAllSelectedItems,
  handleSearchItems,
  handleShowSearch,
  handleCloseSearch,
  label,
  addedItemsCounter,
  isSelected = false,
  isSearch = false,
}) => {
  if (isSearch) {
    return (
      <div className={styles.search}>
        <MInput
          searchInput
          onChange={(event) => handleSearchItems(event.target.value)}
        />
        <div className={styles.closeIcon} onClick={handleCloseSearch}>
          <CloseIcon />
        </div>
      </div>
    );
  }

  return (
    <>
      <Flex vertical>
        <Typography.Text className="form-item-label" strong>
          {label}
        </Typography.Text>
        {isSelected ? (
          <Flex>
            <Checkbox
              className={styles.checkbox}
              checked={isSelected}
              onChange={handleUnselectAllItems}
            />
            <div className={styles.selectedItems}>
              <span className={styles.bold}>
                <span>{addedItemsCounter}</span>
                {label === 'Materials' ? 'MATERIALS' : 'DOCUMENTS'}
              </span>
              <span>ARE SELECTED</span>
            </div>
          </Flex>
        ) : (
          <div className={styles.selectItems}>
            <span>{addedItemsCounter}</span>
            <span>
              {label === 'Materials' ? 'Materials' : 'Documents'} Added
            </span>
            <span className={styles.link} onClick={handleSelectAllItems}>
              Select All
            </span>
          </div>
        )}
      </Flex>

      <div className={styles.container}>
        {!isSelected && (
          <div className={styles.iconItem} onClick={handleShowSearch}>
            <SearchIcon />
          </div>
        )}
        {/* TODO: button is hide while not functionallity */}
        {/* <div className={styles.iconItem}>
          <UploadIcon />
        </div> */}
        {isSelected && (
          <div
            className={styles.iconItem}
            onClick={handleDeleteAllSelectedItems}
          >
            <DeleteIcon />
          </div>
        )}
        {isSelected ? (
          <div className={styles.iconItem} onClick={handleUnselectAllItems}>
            <CloseIcon />
          </div>
        ) : (
          <MButton
            className={styles.button}
            type="secondary"
            onClick={handleAddMaterial}
          >
            <PlusAddIcon /> Add
          </MButton>
        )}
      </div>
    </>
  );
};

export default MaterialActions;
